import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let age = class age extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
    this.answer2 = "y";
    this.options = [{
      label: "岁",
      value: "y"
    }, {
      label: "月",
      value: "m"
    }, {
      label: "天",
      value: "d"
    }];
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.number || 0;
        this.answer2 = value.answer.unit || "y";
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], age.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], age.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], age.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], age.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], age.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], age.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], age.prototype, "dataChage", null);
age = __decorate([Component({
  name: "age"
})], age);
export default age;